var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dashboard-layout', {
    attrs: {
      "title": "비대면 면접",
      "topBtn": "",
      "fullHeight": ""
    }
  }, [_c('template', {
    slot: "topBtn"
  }, [_c('interview-view', {
    attrs: {
      "mode": "list"
    },
    scopedSlots: _vm._u([{
      key: "create",
      fn: function (_ref) {
        var loading = _ref.loading;
        return [_c('interview-form', {
          on: {
            "input": _vm.updateItem
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref2) {
              var attrs = _ref2.attrs,
                on = _ref2.on;
              return [_c('v-btn', _vm._g(_vm._b({
                attrs: {
                  "color": "secondary"
                }
              }, 'v-btn', Object.assign({}, attrs, {
                loading
              }), false), on), [_c('span', [_vm._v(" 비대면 면접 생성 ")])])];
            }
          }], null, true)
        })];
      }
    }])
  })], 1), _c('template', {
    slot: "contents"
  }, [_vm.items.length ? [_c('div', {
    staticClass: "v-cards"
  }, [_vm._l(_vm.items, function (item, index) {
    return [_c('interview-list-item', _vm._g(_vm._b({
      key: item._id,
      model: {
        value: _vm.items[index],
        callback: function ($$v) {
          _vm.$set(_vm.items, index, $$v);
        },
        expression: "items[index]"
      }
    }, 'interview-list-item', {
      loading: _vm.loading
    }, false), {
      update: _vm.update,
      remove: _vm.remove,
      input: _vm.updateItem
    }))];
  })], 2), _c('v-pagination', {
    attrs: {
      "value": _vm.page,
      "length": _vm.pageCount,
      "total-visible": 11,
      "color": "primary"
    },
    on: {
      "input": function (page) {
        return _vm.$router.push({
          query: Object.assign({}, _vm.$route.query, {
            page
          })
        });
      }
    }
  })] : [_c('v-layout', {
    staticClass: "w-100 h-100 grey-f7 rounded-lg pa-20",
    attrs: {
      "column": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('p', {
    staticClass: "page-text--lg line-height-15 text-center mb-12 mb-lg-32"
  }, [_vm._v(" 안녕하세요, 담당자님. "), _c('br'), _vm._v(" 생성된 면접이 없습니다. ")]), _c('interview-form', {
    on: {
      "input": _vm.updateItem
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref3) {
        var attrs = _ref3.attrs,
          on = _ref3.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "v-btn--column",
          attrs: {
            "text": "",
            "height": "auto",
            "color": "transparent"
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "icon icon-plus-lg"
        }), _c('span', {
          staticClass: "mt-6 mt-lg-14 grey-9--text"
        }, [_vm._v("면접 생성하기")])])];
      }
    }])
  })], 1)]], 2)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }